import gql from "graphql-tag"

const mutation = gql`
  mutation RemoveActiveSession($userId: ID!, $sessionId: ID!) {
    loginRemoveActiveSession(userId: $userId, sessionId: $sessionId)
  }
`

export const toString = mutation.loc.source.body

export default mutation
